"use client";
import { createAuthClient } from "better-auth/react";
import {
  adminClient,
  emailOTPClient,
  inferAdditionalFields,
} from "better-auth/client/plugins";
import type { auth } from "@/lib/auth";

/**
 * Client better-auth (konvensi: `src/lib/auth-client.ts` — persis demo resmi).
 * - `inferAdditionalFields` menurunkan tipe additionalFields (status, username,
 *   bio, title, avatarUrl, examPreferences, totalXp, isProfileComplete, role)
 *   dari instance server (type-only import — ter-erase di bundle client).
 * - `emailOTPClient` membuka `authClient.emailOtp.*` (resend/reset OTP).
 * - `adminClient` membuka `authClient.admin.*` + tipe role di session client.
 */
export const authClient = createAuthClient({
  plugins: [inferAdditionalFields<typeof auth>(), emailOTPClient(), adminClient()],
});

export type Session = typeof authClient.$Infer.Session;
